import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Modal, Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import withTranslations from 'app/components/HOGs/withTranslations';
import { getTourLink } from '../../../Utility/utility';

const { confirm } = Modal;

const TourItem = ({
  item,
  deleteAvailable,
  isLinkEnabled = false,
  TourBasketDataDelete,
  tr,
}) => {
  const okText = tr.Yes;
  const cancelText = tr.No;

  const showDeleteConfirm = (el, title, okText, cancelText, callback) => {
    confirm({
      title,
      okText,
      cancelText,
      okType: 'danger',
      onOk() {
        callback([el.id]);
      },
      onCancel() {
        return null;
      },
    });
  };
  const viewLink = useMemo(() => getTourLink(item.title, item.id));

  return (
    <div className="listItem">
      <div>{item.title}</div>
      {isLinkEnabled && (
        <Button type="link" className="view_tour_link">
          <Link to={`${viewLink}`}>{tr.View}</Link>
        </Button>
      )}

      {deleteAvailable ? (
        <DeleteOutlined
          className="dltIcon"
          onClick={() => {
            showDeleteConfirm(
              item,
              tr['Remove this from the list?'],
              okText,
              cancelText,
              TourBasketDataDelete
            );
          }}
        />
      ) : null}
    </div>
  );
};

export default withTranslations(TourItem);
